/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_SchoolInputs */

const da_billing_plan_school = /** @type {(inputs: Billing_Plan_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skole`)
};

/** @type {(inputs: Billing_Plan_SchoolInputs) => LocalizedString} */
const en_billing_plan_school = da_billing_plan_school;

/**

* @param {Billing_Plan_SchoolInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_school = /** @type {((inputs?: Billing_Plan_SchoolInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_SchoolInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_school(inputs)
	return /** @type {LocalizedString} */ ("Skole")
});